import axios from 'axios';
import type { AgendaEvento } from '@eleg360/types';

const API_URL = import.meta.env.VITE_API_URL || '/api';

export const agendaApi = {
  create: async (
    data: {
      titulo: string;
      tipo: string;
      inicio: string;
      fim: string;
      uf?: string;
      municipio?: string;
      bairro?: string;
      endereco?: string;
      publico_alvo?: string;
      convites?: string[];
      confirmacoes?: string[];
      publico?: boolean;
    },
    token: string,
  ) => {
    const res = await axios.post<AgendaEvento>(`${API_URL}/gab/agenda-eventos`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  list: async (token: string) => {
    const res = await axios.get<AgendaEvento[]>(`${API_URL}/gab/agenda-eventos`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  get: async (id: string, token: string) => {
    const res = await axios.get<AgendaEvento>(`${API_URL}/gab/agenda-eventos/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  update: async (id: string, data: Partial<AgendaEvento>, token: string) => {
    const res = await axios.put<AgendaEvento>(`${API_URL}/gab/agenda-eventos/${id}`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  delete: async (id: string, token: string) => {
    await axios.delete(`${API_URL}/gab/agenda-eventos/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
};
